import { ISelectOption } from '../interfaces/select-option.interface';

export const SORT_ORDERS: ISelectOption[] = [
  { key: 'asc', name: 'Ascending' },
  { key: 'desc', name: 'Descending' },
];
